/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCopyColumn: {
  name: 'copy-column';
  data: string;
} = {
  name: 'copy-column',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H10a2 2 0 0 0-.589.088A.996.996 0 0 0 9 2H4Zm16 10h-4V4h4v8Zm-6 0V4h-4v8h4ZM8 4H4v6h4V4Zm6.707 13.707a1 1 0 0 0-1.414-1.414l-2 2a1 1 0 0 0 0 1.414l2 2a1 1 0 0 0 1.414-1.414L14.414 20H18a1 1 0 1 0 0-2h-3.586l.293-.293Z" fill="currentColor"/></svg>`,
};
